import { ThemeConfig } from 'antd';

import palette from '../default/palette';

const layout = {
  colorBgLayout: palette.gray[0],
  borderRadius: 4
} as ThemeConfig['token'];

const colors = {
  colorPrimary: '#0D2772',
  colorBgBase: palette.gray[2],
  colorInfoBg: palette.alpha(palette.gray[12], 0.03),
  colorIcon: palette.alpha(palette.gray[12], 0.85),
  controlItemBgActive: palette.alpha(palette.gray[0], 0.25),
  colorTextPlaceholder: palette.alpha(palette.gray[0], 0.25),
  colorTextHeading: '#000',
  colorText: '#000',
  colorTextBase: palette.alpha(palette.gray[12], 0.85),
  colorTextSecondary: palette.alpha(palette.gray[12], 0.65),
  colorTextTertiary: palette.alpha(palette.gray[12], 0.45),
  colorTextQuaternary: palette.alpha(palette.gray[12], 0.25)
} as ThemeConfig['token'];

const error = {
  colorErrorText: palette.red[2],
  colorErrorBorder: palette.alpha(palette.red[5], 0.2),
  colorErrorBg: palette.alpha(palette.gray[12], 0.08)
} as ThemeConfig['token'];

const tokens = {
  ...layout,
  ...colors,
  ...error
} as ThemeConfig['token'];

export default tokens;
